export class Deadzone {
    public name: string;
    public zone: Phaser.GameObjects.Zone;
    public canHover: boolean;
    public canDrive: boolean;

    constructor(name: string, canHover: boolean, canDrive: boolean) {
        this.name = name;
        this.zone =  null;
        this.canDrive = canDrive;
        this.canHover = canHover;
    }

}



// WEBPACK FOOTER //
// ./src/games/LandscapingGame/objects/Deadzone.ts